




























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import { CommonModule, UserModule } from '../../../store'
import { disposeSearchParamsForCM, getArrChildForTree, getNameTextInOptions, findItemForTree } from '../../../utils/toolsForCommon'
import { encode } from 'js-base64'
import { columnForCapitalShiftTo } from '@/utils/columnForTable'
@Component({
  name: 'CapitalShiftToHistoryForAppropriation',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../../components/common/searchModule.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue')
  }
})
export default class CapitalShiftToHistoryForAppropriation extends Vue {
  public loading = false
  public filterText: string = ''
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '转入时间',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择转入时间',
      show: true,
      disabled: false
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'input',
      value: '',
      placeholder: '请输入食堂专户账号',
      show: true,
      disabled: false
    },
    {
      title: '食堂专户开户行',
      key: 'depositBank',
      type: 'input',
      value: '',
      placeholder: '请输入食堂专户开户行',
      show: true,
      disabled: false
    },
    {
      title: '审批日期',
      key: 'dateIntervalForshenpiriqi',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择审批日期',
      show: true,
      disabled: false
    },
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'input',
    //   value: '',
    //   placeholder: '请输入操作人',
    //   show: true,
    //   disabled: false
    // },
    {
      title: '审批人',
      key: 'auditor',
      type: 'input',
      value: '',
      placeholder: '请输入审批人',
      show: true,
      disabled: false
    },
    {
      title: '状态',
      key: 'status',
      type: 'select',
      value: '',
      placeholder: '请选择状态',
      selectOptions: [],
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    ...columnForCapitalShiftTo,
    // {
    //   title: '当前操作人',
    //   key: 'updatedBy',
    //   type: 'text',
    //   showStateForTableHeader: 'unilaminar',
    //   width: '200px'
    // }
    {
      title: '审批人',
      key: 'auditors',
      type: 'listForTitleValueShow',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '审批记录',
      key: 'lookAllOperationManForCapitalShiftToHistoryOfCityInvestment',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '审批记录(有驳回)',
      key: 'failForCapitalShiftToHistoryOfCityInvestment',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '收据单',
      key: 'receiptForCapitalShiftToHistoryOfCityInvestment',
      type: 'primary',
      size: 'mini'
    }
    // {
    //   title: '通过',
    //   key: 'resolveForCapitalShiftToHistoryOfCityInvestment',
    //   type: 'success',
    //   size: 'mini'
    // },
    // {
    //   title: '驳回',
    //   key: 'rejectForCapitalShiftToHistoryOfCityInvestment',
    //   type: 'danger',
    //   size: 'mini'
    // },
    // {
    //   title: '删除',
    //   key: 'delete',
    //   type: 'danger',
    //   size: 'mini'
    // }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    // {
    //   title: "<span class='el-icon-bottom'></span>下载资金转入记录模板",
    //   key: 'exportTemplate',
    //   type: 'primary',
    //   size: '',
    //   canExportOutFlag: true,
    //   titleCopy: "<span class='el-icon-bottom'></span>下载资金转入记录模板",
    //   exportResultFileName: '资金转入记录模板.xlsx',
    //   exportLoading: "<span class='el-icon-loading'></span>正在下载中，请稍后",
    //   exportError: '抱歉，下载失败',
    //   exportSuccess: '下载成功'
    // },
    // {
    //   title: "<span class='el-icon-top'></span>导入资金转入记录",
    //   key: 'uploadExcel',
    //   type: 'success',
    //   size: '',
    //   canExportOutFlag: true,
    //   titleCopy: "<span class='el-icon-top'></span>导入资金转入记录",
    //   exportLoading: "<span class='el-icon-loading'></span>正在导入中，请稍后",
    //   exportError: '抱歉，导入失败',
    //   exportSuccess: '导入成功',
    //   isImportInto: true
    // },
    // 纯前端导出：
    // {
    //   title: "<span class='el-icon-bottom'></span>导出当前页资金转入记录列表",
    //   key: 'exportExcel',
    //   type: 'primary',
    //   size: '',
    //   canExportOutFlag: true,
    //   titleCopy: "<span class='el-icon-bottom'></span>导出当前页资金转入记录列表",
    //   exportResultFileName: '资金转入记录列表.xlsx',
    //   exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
    //   exportError: '抱歉，导出失败',
    //   exportSuccess: '导出成功'
    // }
    // 现改为后端导出：
    {
      title: "<span class='el-icon-bottom'></span>导出资金转入记录列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出资金转入记录列表",
      exportResultFileName: '资金转入记录列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  public whoUploadForItem: OperationItemType | null = null
  // 枚举选项：
  // 资金转入记录：
  public optionsForAuditStatus: Array<OptionItemType> = [
    {
      name: '已取消',
      value: -1
    },
    {
      name: '审核岗待审批',
      value: 0
    },
    {
      name: '拨付岗待审批',
      value: 4
    },
    {
      name: '学校待确认',
      value: 1
    },
    {
      name: '已驳回',
      value: 2
    },
    {
      name: '已确认',
      value: 3
    }
  ]
  public optionsForAuditStatusForTagType: Array<OptionItemType> = [
    {
      name: 'danger',
      value: -1
    },
    {
      name: '',
      value: 0
    },
    {
      name: '',
      value: 4
    },
    {
      name: 'success',
      value: 1
    },
    {
      name: 'danger',
      value: 2
    },
    {
      name: 'success',
      value: 3
    }
  ]
  // 查看驳回详情：
  public visibleForFailReasonDetailList: boolean = false
  public failReasonDetailList: Array<any> = []
  public loadingForFailReasonDetailList: boolean = false
  // 20220922新增 列自定义选择展示：
  public checkedListForTableColumnList: Array<string> = []

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this.$refs.tree as any).filter(val)
  }

  async mounted (): Promise<void> {
    await CommonModule.getTreeDataForSubOrganization()
    await CommonModule.getTreeDataForOrganization()
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.disposeForColumnOperationList()
    this.$nextTick(() => {
      ;(this as any).$refs.tree.setCheckedKeys(getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id))
      this.getTableDataList()
    })
    this.checkedListForTableColumnList = [...this.tableColumnList.slice(0).map(item => item.key)]
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'status':
          item.selectOptions = this.optionsForAuditStatus
          break
      }
      return item
    })
  }

  // 列按钮初始化：
  disposeForColumnOperationList () {
    if (!this.userInfoAuthority.includes(this.allRole.CapitalCityInvestment.CapitalCityInvestment_Management_Delete_Capital_Transfer_Accounts_History.code)) {
      this.columnOperationList = this.columnOperationList.filter(item => item.key !== 'delete')
    }
  }

  // 操作按钮：
  operationForButton ({ key }, row, uploadFile?: File) {
    switch (key) {
      case 'detail':
        const detail = encode(JSON.stringify(row))
        this.$router.push({ name: 'CapitalShiftToHistoryDetail', query: { detail } })
        break
      case 'lookAllOperationManForCapitalShiftToHistoryOfCityInvestment':
      case 'failForCapitalShiftToHistoryOfCityInvestment':
        this.visibleForFailReasonDetailList = true
        this.getFailReasonDetail(row.id)
        break
      case 'receiptForCapitalShiftToHistoryOfCityInvestment':
        // targetId: 对应的业务id，type为1时为资金转入记录id；type为2时为资金拨付申请id
        // type: 收据类型：1：资金转入；2：资金拨付
        this.$router.push({ name: 'CapitalReceiptDetail', query: { targetId: row.id, type: '1', source: 'cityInvestment' } })
        break
      // case 'resolveForCapitalShiftToHistoryOfCityInvestment':
      //   this.operationForConfirmForCapitalShiftToHistory([row.id], 1, '确定要通过此资金转入记录吗？')
      //   break
      // case 'rejectForCapitalShiftToHistoryOfCityInvestment':
      //   this.operationForConfirmForCapitalShiftToHistory([row.id], 0, '确定要驳回此资金转入记录吗？')
      //   break
      // case 'delete':
      //   const { id } = row
      //   this.operationForDelete([id], '确定要删除此资金转入记录吗？')
      //   break
      // case 'exportTemplate':
      //   // 开始下载：
      //   this.operationForButtonOfTableHeader.forEach(async item => {
      //     if (item.key === 'exportTemplate') {
      //       if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
      //       item.canExportOutFlag = false
      //       item.title = item.exportLoading
      //       const result = await (this as any).$http.capitalTransferDownloadTemplate()
      //       if (result.status !== 200) {
      //         this.$message.error(item.exportError)
      //         item.canExportOutFlag = true
      //         item.title = item.titleCopy
      //         return false
      //       }
      //       const blob = new Blob([result.data], {
      //         type: 'application/vnd.ms-excel'
      //       })
      //       const objectUrl = window.URL.createObjectURL(blob)
      //       const a = document.createElement('a')
      //       a.href = objectUrl
      //       a.download = item.exportResultFileName
      //       a.click()
      //       // 释放临时的对象url
      //       window.URL.revokeObjectURL(objectUrl)
      //       this.$message.success(item.exportSuccess)
      //       item.canExportOutFlag = true
      //       item.title = item.titleCopy
      //     }
      //   })
      //   break
      // case 'uploadExcel':
      //   // 开始导入：
      //   this.operationForButtonOfTableHeader.forEach(async item => {
      //     if (item.key === 'uploadExcel') {
      //       if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
      //       item.canExportOutFlag = false
      //       item.title = item.exportLoading
      //       const fileObj = uploadFile['file']
      //       const params = new FormData()
      //       params.append('multipartFile', fileObj)
      //       const { data: result } = await (this as any).$http.capitalTransferImport(params)
      //       if (result.code !== 200) {
      //         this.$message.error(result.msg ? result.msg : item.exportError)
      //         item.canExportOutFlag = true
      //         item.title = item.titleCopy
      //         return false
      //       };
      //       this.$message.success(item.exportSuccess)
      //       item.canExportOutFlag = true
      //       item.title = item.titleCopy
      //       this.getTableDataList()
      //     }
      //   })
      //   break
      // case 'exportExcel':
      //   // 开始导出：纯前端导出
      //   this.operationForButtonOfTableHeader.forEach(async item => {
      //     if (item.key === 'exportExcel') {
      //       if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
      //       item.canExportOutFlag = false
      //       item.title = item.exportLoading
      //       // start:
      //       const keysList = this.tableColumnList.map(v => v.key)
      //       const dataRes = ((this as any).tableDataList || []).map(v => {
      //         return keysList.map(vv => {
      //           let res = ''
      //           switch (vv) {
      //             case 'town':
      //             case 'school':
      //               const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', v[vv])
      //               if (!Object.keys(NodeRes).length) {
      //                 res = '- -'
      //               } else {
      //                 res = NodeRes['name']
      //               }
      //               break
      //             default:
      //               res = v[vv]
      //           }
      //           return res
      //         })
      //       })
      //       import('../../../plugins/xlsx/exportExcel').then(excel => {
      //         let tHeader = this.tableColumnList.map(v => v.title)
      //         try {
      //           excel.export_json_to_excel({
      //             multiHeader2: [], // 这里是第一行的表头
      //             multiHeader: [], // 这里是第二行的表头
      //             header: tHeader, // 这里应该是算第三行的表头
      //             data: dataRes,
      //             merges: [],
      //             filename: item.exportResultFileName
      //           })
      //           this.$message.success(item.exportSuccess)
      //           item.canExportOutFlag = true
      //           item.title = item.titleCopy
      //         } catch (err) {
      //           this.$message.error(item.exportError)
      //           item.canExportOutFlag = true
      //           item.title = item.titleCopy
      //         }
      //       })
      //       // end
      //     }
      //   })
      //   break
      case 'exportExcel':
        // 开始导出：
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
            const params = {
              ...searchParams,
              schoolIds: (this as any).$refs.tree.getCheckedKeys(true),
              role: 'URBAN_INVESTMENT_TRANSFER',
              completed: 1
            }
            const result = await (this as any).$http.capitalTransferExport(params)
            if (result.status !== 200) {
              this.$message.error(item.exportError)
              item.canExportOutFlag = true
              item.title = item.titleCopy
              return false
            };
            const blob = new Blob([result.data], {
              type: 'application/vnd.ms-excel'
            })
            const objectUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = objectUrl
            a.download = this.orgName + '--' + item.exportResultFileName
            a.click()
            // 释放临时的对象url
            window.URL.revokeObjectURL(objectUrl)
            this.$message.success(item.exportSuccess)
            item.canExportOutFlag = true
            item.title = item.titleCopy
          }
        })
        break
    }
  }

  // operationForConfirmForCapitalShiftToHistory (ids: Array<string | number>, operation: number, confirmText: string) {
  //   let messageText = ''
  //   // 0表示取消，1表示确认
  //   switch (operation) {
  //     case 0:
  //       messageText = '操作成功，已驳回'
  //       break
  //     case 1:
  //       messageText = '操作成功，已通过'
  //       break
  //   }
  //   this.$confirm(confirmText, '提示', {
  //     confirmButtonText: `确定`,
  //     cancelButtonText: `取消`,
  //     type: 'warning'
  //   }).then(async () => {
  //     let { data: result } = await (this as any).$http.capitalTransferApprove({
  //       ids,
  //       audit: operation ? true : false,
  //       role: 'URBAN_INVESTMENT_TRANSFER'
  //     })
  //     if (result.code !== 200) return this.$message.error(result.msg)
  //     this.$message.success(messageText)
  //     this.getTableDataList()
  //   }).catch(() => {})
  // }

  // operationForConfirmInBatches () {
  //   if (!(this as any).$refs.refForTableModule.multipleSelection.length) return this.$message.warning('请选择需要通过的项')
  //   this.operationForConfirmForCapitalShiftToHistory((this as any).$refs.refForTableModule.multipleSelection.map(item => item.id), 1, '确定要通过选中的资金转入记录吗？')
  // }

  // operationForCancelInBatches () {
  //   if (!(this as any).$refs.refForTableModule.multipleSelection.length) return this.$message.warning('请选择需要驳回的项')
  //   this.operationForConfirmForCapitalShiftToHistory((this as any).$refs.refForTableModule.multipleSelection.map(item => item.id), 0, '确定要驳回选中的资金转入记录吗？')
  // }

  // 删除：
  // operationForDelete (ids: Array<string | number>, confirmText: string) {
  //   this.$confirm(confirmText, '提示', {
  //     confirmButtonText: '确定删除',
  //     cancelButtonText: '取消删除',
  //     type: 'error'
  //   }).then(async () => {
  //     let { data: result } = await (this as any).$http.capitalTransferDel({ ids: ids.join(',') })
  //     if (result.code !== 200) return this.$message.error(result.msg)
  //     this.$message.success('删除成功！')
  //     this.getTableDataList()
  //   }).catch(() => {})
  // }

  // operationForDeleteInBatches () {
  //   if (!(this as any).$refs.refForTableModule.multipleSelection.length) return this.$message.warning('请选择需要删除的项')
  //   this.operationForDelete((this as any).$refs.refForTableModule.multipleSelection.map(item => item.id), '确定要删除选中的资金转入记录吗？')
  // }

  async getFailReasonDetail (id) {
    try {
      this.failReasonDetailList = []
      this.loadingForFailReasonDetailList = true
      const params = {
        auditScene: 2, // 1:会计凭证审核;2:资金转账记录;3:资金使用申请
        id
      }
      const { data: result } = await (this as any).$http.getLogAudit(params)
      this.loadingForFailReasonDetailList = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.failReasonDetailList = (result.data || []).map(item => {
        let res = ''
        const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item['operatorOrg'])
        if (!Object.keys(NodeRes).length) {
          res = '- -'
        } else {
          res = NodeRes['name']
        }
        item.description = `
          ${item.audit ? '通过' : '驳回'}
          ----
          ${res}
          组织节点的用户（
          ${item['operatorName']}
          ）在
          ${item['time']}
          进行处理，处理完的状态为：
          ${getNameTextInOptions(this.optionsForAuditStatus, item['resultStatus'])}
          ，处理原因为：
          ${item['reason'] ? item['reason'] : '- -'}
        `
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForUploadInner (item) {
    this.whoUploadForItem = item
  }

  mySelfUpload (param: File) {
    this.operationForButton(this.whoUploadForItem, {}, param)
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams,
        schoolIds: (this as any).$refs.tree.getCheckedKeys(true),
        role: 'URBAN_INVESTMENT_TRANSFER',
        completed: 1
      }
      const { data: result } = await (this as any).$http.capitalTransferQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['tagType'] = getNameTextInOptions(this.optionsForAuditStatusForTagType, item.status)
        item.status = getNameTextInOptions(this.optionsForAuditStatus, item.status)
        item.time = item.time.split(' ')[0]
        item.auditors = item.auditors || []
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  handleCheckChange (): void {
    this.getTableDataList()
  }

  // 暂时不作限制
  beforeUpload () {}
}
